import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ReactionResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/reactions';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}